import type { CheckTask } from '@/interfaces/CheckTask';
import { type CheckOfflineMetadata, offlineDatabase } from '@/offlineDatabase'

export const OfflineDatabaseService = () => {
  const getCheckByCheckId = async (checkId: string): Promise<CheckOfflineMetadata | undefined> => {
    var t = await offlineDatabase.checkOfflineMetadata.where("checkId").equals(checkId).first();
    return t
  }
  const hasAlreadyBeenComplete = async (checkId: string): Promise<boolean> => {
    return await offlineDatabase.completed.where('checkId').equals(checkId).count() > 0
  }

  const getCheckByGuid = (checkGuid: string): Promise<CheckOfflineMetadata | undefined> => {
    return offlineDatabase.checkOfflineMetadata.where('guid').equals(checkGuid).first()
  }

  const getLastCompletedTaskId = async (checkId: string): Promise<string | undefined> => {
    if (!checkId) {
      return undefined
    }
    
    const check = await getCheckByCheckId(checkId)

    if (!check) {
      return undefined
    }

    const completeTasks = check.check.checkTasks.filter((c:CheckTask) => c.isCompleted);
    const lastCompletedTask = completeTasks[completeTasks.length-1]

    if (!lastCompletedTask) {
      return undefined
    }

    return lastCompletedTask.id
  }

  const getLastCompletedTaskIdByCheckOfflineGuid = async (
    checkOfflineGuid?: string
  ): Promise<string | undefined> => {
    if (!checkOfflineGuid) {
      return undefined
    }

    const check = await getCheckByGuid(checkOfflineGuid)

    if (!check) {
      return undefined
    }
    const completeTasks = check.check.checkTasks.filter((c:CheckTask) => c.isCompleted);
    const lastCompletedTask = completeTasks[completeTasks.length-1]

    if (!lastCompletedTask) {
      return undefined
    }

    return lastCompletedTask.id
  }

  const getAllChecks = async (): Promise<CheckOfflineMetadata[]> => {
    return offlineDatabase.checkOfflineMetadata.toArray()
  }

  const clearAllChecks = () => {
    offlineDatabase.checkOfflineMetadata.clear()
  }

  const deleteCheck = (id: string): void => {
    offlineDatabase.checkOfflineMetadata.delete(id)
  }

  return {
    getCheckByCheckId,
    getCheckByGuid,
    getLastCompletedTaskId,
    getLastCompletedTaskIdByCheckOfflineGuid,
    getAllChecks,
    clearAllChecks,
    deleteCheck,
    hasAlreadyBeenComplete
  }
}
